import { Form } from '~/shared/api'

export default class UpdateGroupForm extends Form {
  constructor() {
    super()
    this.method = 'PATCH'
  }
}
